var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.ifM)?_c('m-header'):_c('wl-header'),_c('router-view'),(_vm.ifM)?_c('m-footer'):_c('wl-footer'),_c('wl-notice',{ref:"notice"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }